module.exports = ".card-pet {\r\n    height: 170px\r\n}\r\n"